(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pack-add-to-cart-buttons"] && !Shopify.designMode) return;
  try {
    // Función para crear y mostrar la nota de éxito de forma permanente
  const showSuccessNote = (packQuantity) => {
    const noteElement = document.getElementById('pack-success-note');
    if (!noteElement) return;

    const packText = `Pack de ${packQuantity}`;

    noteElement.innerHTML = `
      <strong>Nota:</strong> ${packText} ha sido agregado al carrito. 
      Puede seguir agregando más productos, pero debe refrescar la página 
      para ver la cantidad actualizada en el carrito.
    `;
    noteElement.style.display = 'block';
  };


  // Script principal
  document.addEventListener('DOMContentLoaded', () => {
    // Solo si estamos en la vista donde el fragmento se renderiza (es decir, si el usuario está logueado)
    const packForms = document.querySelectorAll('[data-pack-form]');

    packForms.forEach(form => {
      form.addEventListener('submit', async (event) => {
        event.preventDefault();

        const submitButton = form.querySelector('button[type="submit"]');
        
        // Evitamos el doble envío *mientras* la petición está en curso.
        const originalText = submitButton.textContent;
        
        if (submitButton.disabled) {
            return;
        }
        
        submitButton.disabled = true;
        submitButton.textContent = 'Agregando...';

        const formData = new FormData(form);
        const packQuantity = form.getAttribute('data-pack-form');
        
        const sectionsToUpdate = 'cart-icon-bubble,header-group'; 
        
        const body = {
          items: [{
            id: formData.get('id'),
            quantity: formData.get('quantity')
          }],
          sections: sectionsToUpdate.split(',')
        };

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify(body)
          });

          const data = await response.json();

          if (response.ok) {
            submitButton.textContent = '¡Agregado!';
            
            showSuccessNote(packQuantity); 
            
            if (data.sections) {
              for (const sectionId of sectionsToUpdate.split(',')) {
                if (data.sections[sectionId]) {
                  const newHtml = data.sections[sectionId];
                  const targetElement = document.querySelector(`#shopify-section-${sectionId}, .${sectionId}`); 
                  
                  if (targetElement) {
                      targetElement.innerHTML = newHtml;
                  }
                }
              }
            }

            document.dispatchEvent(new CustomEvent('cart:add', {
              bubbles: true,
              detail: { cart: data, form: form }
            }));
            
            // Rehabilitación rápida
            setTimeout(() => {
              submitButton.textContent = originalText;
              submitButton.disabled = false;
            }, 500); 
            
          } else {
            alert(`Error al agregar: ${data.description || data.message || 'Verifica la consola.'}`);
            submitButton.textContent = originalText;
            submitButton.disabled = false;
          }

        } catch (error) {
          console.error('Error AJAX:', error);
          submitButton.textContent = originalText;
          submitButton.disabled = false;
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
